<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: false
    },
    typeclass: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      activeClass: 'text-success',
      statusTemp: "SUCCESS"
    };
  },
  methods: {
    goHome() {
      this.$router.replace("/home")
    }
  }
};
</script>
<template>
  <van-row>
    <van-col span="24">
      <div class="unsubscribe-content">
        <img v-if="statusTemp == 'SUCCESS' " class="image-successfull" src="@/static/icon-unsubscribe.png"/>
        <img v-else-if="statusTemp == 'FAILD' " class="image-successfull" src="@/static/report_problem_24px.png"/>
        <div>
          <h4 class="unsubscribe-notify" :class="`${typeclass}`">{{ title }} </h4>
          <p class="unsubscribe-description">{{ desc }}</p>
        </div>
      </div>
    </van-col>
    <van-col span="24" class="cs-btn-bill van-payment-success">
      <van-button @click="goHome" color="#EF5350" block class="btn-home">Home</van-button>
    </van-col>
  </van-row>
</template>

<style>
.unsubscribe-content {
  margin: 16px;
  height: 412px;
  border-radius: 8px;
  background: #F5F8FF;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding-top: 50px;
  gap: 20px;
  margin-bottom: 100px;
}

.image-successfull {
  width: 64px;
  height: 64px;
}

.unsubscribe-notify {
  color: #0D993D;
  text-align: center;
  font-family: SF Pro Text;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0px;
}

.unsubscribe-description {
  color: #101828;
  text-align: center;
  font-family: SF Pro Text;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.success {
  color: #0D993D !important;
}

.danger {
  color: #E53E3E !important;
}

.cs-btn-bill {
  display: flex !important;
  justify-content: center;
}

.van-payment-success {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 16px 16px 32px 16px;
}

.btn-home {
  max-width: 333px;
  max-height: 44px;
  border-radius: 8px;
}

.badge {
  padding: .4rem .375rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 50px;
  display: inline-block;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}

.badge-success {
  background: #ECFDF3;
  color: #027A48;
}

.badge-danger {
  background: rgba(233, 22, 7, 0.1);
  color: #E81707;
}

</style>
